module.exports = {
      id: "icon-appstore-usage",
      viewBox: "0 0 189.408 63.551",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-appstore",
      toString: function () {
        return this.url;
      }
    }